import {
  setUser,
  setAccessToken,
  logout,
  setError,
  setLoader,
  setTokenForUserRole,
  setToAuthorizationData,
  setToHideSidebar,
  setFallBackRefreshToken,
} from './AuthSlice';
import useCustomDispatch from '../../hooks/useDispatch';

const AuthFacade = () => {
  const { customeDispatchFunction } = useCustomDispatch();
  const setAuthUser = (payload) => {
    customeDispatchFunction(setUser(payload));
  };
  const setToken = (payload) => {
    customeDispatchFunction(setAccessToken(payload));
  };
  const handleLogout = () => {
    customeDispatchFunction(logout());
  };
  const handleLoginFieldError = (payload) => {
    customeDispatchFunction(setError(payload));
  };
  const handleLoader = (payload) => {
    customeDispatchFunction(setLoader(payload));
  };
  const accessTokenForUserRole = (payload) => {
    customeDispatchFunction(setTokenForUserRole(payload));
  };

  const setAuthorizationData = (payload) => {
    customeDispatchFunction(setToAuthorizationData(payload));
  };
  const setHideSidebar = (payload) => {
    customeDispatchFunction(setToHideSidebar(payload));
  };
  const fallBackRefreshToken = (payload) => {
    customeDispatchFunction(setFallBackRefreshToken(payload));
  };

  return {
    setAuthUser,
    setToken,
    handleLogout,
    handleLoginFieldError,
    handleLoader,
    accessTokenForUserRole,
    setAuthorizationData,
    setHideSidebar,
    fallBackRefreshToken
  };
};

export default AuthFacade;
